import React from 'react'
import TopPanelMenu from 'components/TopPanelMenu'

export default class extends React.Component {
  render() {
    return (
      <TopPanelMenu
        items={[
          {to: '/aggreated-attribution-explorer', title: 'Explorer', onlyActiveOnIndex: true}
        ]}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/menu.js